import React, { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
// import { IReduxState } from '../../../app/types';
import Icon from "../../../base/icons/components/Icon";
import { IconMessage } from "../../../base/icons/svg";
// import { browser } from '../../../base/lib-meet-hour';
// import { withPixelLineHeight } from '../../../base/styles/functions.web';
import PollItem from "./PollItem";
import { isLocalParticipantModerator } from "../../../base/participants";
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
        },
        emptyIcon: {
            width: "100px",
            padding: "16px",
            "& svg": {
                width: "100%",
                height: "auto",
            },
        },
        emptyMessage: {
            // ...withPixelLineHeight(theme.typography.bodyLongBold),
            color: '#C2C2C2',
            padding: "0 24px",
            textAlign: "center",
        },
    };
});
const PollsList = () => {
    const { t } = useTranslation();
    const { classes, theme } = useStyles();
    const polls = useSelector((state) => { var _a; return (_a = state["features/polls"]) === null || _a === void 0 ? void 0 : _a.polls; });
    const pollListEndRef = useRef(null);
    const isModerator = useSelector((state) => isLocalParticipantModerator(state));
    const scrollToBottom = useCallback(() => {
        if (pollListEndRef.current) {
            // Safari does not support options
            const param = {
                behavior: "smooth",
                block: "end",
                inline: "nearest",
            };
            pollListEndRef.current.scrollIntoView(param);
        }
    }, [pollListEndRef.current]);
    useEffect(() => {
        scrollToBottom();
    }, [polls]);
    const listPolls = Object.keys(polls);
    return (React.createElement(React.Fragment, null, listPolls.length === 0 ? (React.createElement("div", { className: classes.container },
        React.createElement(Icon, { className: classes.emptyIcon, color: "#858585", src: IconMessage }),
        React.createElement("span", { className: classes.emptyMessage }, isModerator ? t("polls.results.empty") : t("polls.results.guestempty")))) : (listPolls.map((id, index) => (React.createElement(PollItem, { key: id, pollId: id, ref: listPolls.length - 1 === index
            ? pollListEndRef
            : null }))))));
};
export default PollsList;
